// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.riskAlert_riskAlertCard__oxGUO {
  display: flex;
  background-color: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 12px;
  margin-bottom: 12px;
  transition: all 0.2s ease;
}
.riskAlert_riskAlertCard__oxGUO.riskAlert_unread__uXcJy {
  box-shadow: none;
}
.riskAlert_riskAlertCard__oxGUO:hover {
  background-color: var(--bg3);
  border-color: transparent;
  border-left: 4px solid;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_mainContainer__sEr3e {
  display: flex;
  gap: 12px;
  width: 100%;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_iconContainer__YJ9dc {
  flex-shrink: 0;
  padding: 10px;
  border-radius: 500px;
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_iconContainer__YJ9dc svg {
  width: 20px;
  height: 20px;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_contentContainer__vxWKh {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_headerRow__fdiRF {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_titleRow__FE-Pt {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex: 1 1;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_title__-Zjmx {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
  margin: 0;
  line-height: 1.4;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_timeContainer__BFhjk {
  flex-shrink: 0;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_time__4n-CD {
  font: var(--body-font-four);
  font-weight: 400;
  color: var(--secondary-Text);
  white-space: nowrap;
  margin: 0;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_message__JPPoQ {
  font: var(--body-font-three);
  font-weight: 400;
  line-height: 1.4;
  color: var(--primary-Text);
  margin: 0;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_urgency__cLSsv {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--secondary-Text);
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_urgency__cLSsv .riskAlert_clockIcon__yBdQX {
  width: 16px;
  height: 16px;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_urgency__cLSsv .riskAlert_urgencyText__C9Meh {
  font: var(--body-font-four);
  font-weight: 400;
  color: var(--secondary-Text);
  margin: 0;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_actionsContainer__FSPTq {
  padding-top: 8px;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_actionsLabel__89G5c {
  font: var(--body-font-four);
  font-weight: 500;
  color: var(--secondary-Text);
  margin-bottom: 8px;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_actionButtons__9cQan {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_actionBtn__yx7NR {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font: var(--body-font-four);
  font-weight: 500;
  border-radius: var(--border-radius);
  text-transform: none;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_actionBtn__yx7NR.riskAlert_primary__GaTww {
  background-color: var(--brand);
  color: var(--white);
  border: none;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_actionBtn__yx7NR.riskAlert_primary__GaTww:hover {
  background-color: #96b8ca;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_actionBtn__yx7NR.riskAlert_secondary__G7gFU {
  background-color: transparent;
  color: var(--primary-Text);
  border: 1px solid var(--border);
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_actionBtn__yx7NR.riskAlert_secondary__G7gFU:hover {
  background-color: var(--bg3);
  border-color: var(--brand);
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_dismissLink__i7sLX {
  background: none;
  border: none;
  color: var(--secondary-Text);
  font: var(--body-font-four);
  font-weight: 400;
  cursor: pointer;
  padding: 4px 8px;
}
.riskAlert_riskAlertCard__oxGUO .riskAlert_dismissLink__i7sLX:hover {
  color: var(--primary-Text);
}

@media (max-width: 767px) {
  .riskAlert_riskAlertCard__oxGUO {
    padding: 10px 12px;
  }
  .riskAlert_riskAlertCard__oxGUO .riskAlert_title__-Zjmx {
    font-size: 13px;
  }
  .riskAlert_riskAlertCard__oxGUO .riskAlert_message__JPPoQ {
    font-size: 13px;
  }
  .riskAlert_riskAlertCard__oxGUO .riskAlert_actionButtons__9cQan {
    flex-direction: column;
  }
  .riskAlert_riskAlertCard__oxGUO .riskAlert_actionButtons__9cQan .riskAlert_actionBtn__yx7NR {
    width: 100%;
    justify-content: center;
  }
}
.riskAlert_riskAlertsList__K8kG6 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.riskAlert_emptyRiskAlerts__vDWWM {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  background-color: var(--bg3);
  border-radius: var(--border-radius-large);
}
.riskAlert_emptyRiskAlerts__vDWWM .riskAlert_emptyIcon__hLMB2 {
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}
.riskAlert_emptyRiskAlerts__vDWWM .riskAlert_emptyTitle__Jl40c {
  font: var(--body-font-one);
  font-weight: 600;
  color: var(--primary-Text);
  margin-bottom: 8px;
}
.riskAlert_emptyRiskAlerts__vDWWM .riskAlert_emptyText__Dwm3d {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--secondary-Text);
}`, "",{"version":3,"sources":["webpack://./src/components/notification/riskAlert.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AACD;AACC;EACC,gBAAA;AACF;AAEC;EACC,4BAAA;EACA,yBAAA;EACA,sBAAA;AAAF;AAGC;EACC,aAAA;EACA,SAAA;EACA,WAAA;AADF;AAIC;EACC,cAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AAIE;EACC,WAAA;EACA,YAAA;AAFH;AAMC;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAJF;AAOC;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AALF;AAQC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,SAAA;AANF;AASC;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;EACA,gBAAA;AAPF;AAUC;EACC,cAAA;AARF;AAWC;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,SAAA;AATF;AAYC;EACC,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AAVF;AAaC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,4BAAA;AAXF;AAaE;EACC,WAAA;EACA,YAAA;AAXH;AAcE;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;AAZH;AAgBC;EACC,gBAAA;AAdF;AAiBC;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;AAfF;AAkBC;EACC,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AAhBF;AAmBC;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,mCAAA;EACA,oBAAA;AAjBF;AAmBE;EACC,8BAAA;EACA,mBAAA;EACA,YAAA;AAjBH;AAmBG;EACC,yBAAA;AAjBJ;AAqBE;EACC,6BAAA;EACA,0BAAA;EACA,+BAAA;AAnBH;AAqBG;EACC,4BAAA;EACA,0BAAA;AAnBJ;AAwBC;EACC,gBAAA;EACA,YAAA;EACA,4BAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAtBF;AAwBE;EACC,0BAAA;AAtBH;;AA4BA;EACC;IACC,kBAAA;EAzBA;EA2BA;IACC,eAAA;EAzBD;EA4BA;IACC,eAAA;EA1BD;EA6BA;IACC,sBAAA;EA3BD;EA6BC;IACC,WAAA;IACA,uBAAA;EA3BF;AACF;AAiCA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AA/BD;;AAmCA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,yCAAA;AAhCD;AAkCC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAhCF;AAmCC;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAjCF;AAoCC;EACC,4BAAA;EACA,gBAAA;EACA,4BAAA;AAlCF","sourcesContent":[".riskAlertCard {\r\n\tdisplay: flex;\r\n\tbackground-color: var(--white);\r\n\tborder: 1px solid var(--border);\r\n\tborder-radius: var(--border-radius);\r\n\tpadding: 12px;\r\n\tmargin-bottom: 12px;\r\n\ttransition: all 0.2s ease;\r\n\r\n\t&.unread {\r\n\t\tbox-shadow: none;\r\n\t}\r\n\r\n\t&:hover {\r\n\t\tbackground-color: var(--bg3);\r\n\t\tborder-color: transparent;\r\n\t\tborder-left: 4px solid;\r\n\t}\r\n\r\n\t.mainContainer {\r\n\t\tdisplay: flex;\r\n\t\tgap: 12px;\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.iconContainer {\r\n\t\tflex-shrink: 0;\r\n\t\tpadding: 10px;\r\n\t\tborder-radius: 500px;\r\n\t\twidth: fit-content;\r\n\t\theight: fit-content;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\r\n\t\tsvg {\r\n\t\t\twidth: 20px;\r\n\t\t\theight: 20px;\r\n\t\t}\r\n\t}\r\n\r\n\t.contentContainer {\r\n\t\tflex: 1;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 4px;\r\n\t}\r\n\r\n\t.headerRow {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: flex-start;\r\n\t\tgap: 12px;\r\n\t}\r\n\r\n\t.titleRow {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 8px;\r\n\t\tflex-wrap: wrap;\r\n\t\tflex: 1;\r\n\t}\r\n\r\n\t.title {\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 600;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tmargin: 0;\r\n\t\tline-height: 1.4;\r\n\t}\r\n\r\n\t.timeContainer {\r\n\t\tflex-shrink: 0;\r\n\t}\r\n\r\n\t.time {\r\n\t\tfont: var(--body-font-four);\r\n\t\tfont-weight: 400;\r\n\t\tcolor: var(--secondary-Text);\r\n\t\twhite-space: nowrap;\r\n\t\tmargin: 0;\r\n\t}\r\n\r\n\t.message {\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 400;\r\n\t\tline-height: 1.4;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tmargin: 0;\r\n\t}\r\n\r\n\t.urgency {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 6px;\r\n\t\tcolor: var(--secondary-Text);\r\n\r\n\t\t.clockIcon {\r\n\t\t\twidth: 16px;\r\n\t\t\theight: 16px;\r\n\t\t}\r\n\r\n\t\t.urgencyText {\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 400;\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tmargin: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t.actionsContainer {\r\n\t\tpadding-top: 8px;\r\n\t}\r\n\r\n\t.actionsLabel {\r\n\t\tfont: var(--body-font-four);\r\n\t\tfont-weight: 500;\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tmargin-bottom: 8px;\r\n\t}\r\n\r\n\t.actionButtons {\r\n\t\tdisplay: flex;\r\n\t\tflex-wrap: wrap;\r\n\t\talign-items: center;\r\n\t\tgap: 8px;\r\n\t}\r\n\r\n\t.actionBtn {\r\n\t\tdisplay: inline-flex;\r\n\t\talign-items: center;\r\n\t\tgap: 4px;\r\n\t\tfont: var(--body-font-four);\r\n\t\tfont-weight: 500;\r\n\t\tborder-radius: var(--border-radius);\r\n\t\ttext-transform: none;\r\n\r\n\t\t&.primary {\r\n\t\t\tbackground-color: var(--brand);\r\n\t\t\tcolor: var(--white);\r\n\t\t\tborder: none;\r\n\r\n\t\t\t&:hover {\r\n\t\t\t\tbackground-color: #96b8ca;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.secondary {\r\n\t\t\tbackground-color: transparent;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tborder: 1px solid var(--border);\r\n\r\n\t\t\t&:hover {\r\n\t\t\t\tbackground-color: var(--bg3);\r\n\t\t\t\tborder-color: var(--brand);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.dismissLink {\r\n\t\tbackground: none;\r\n\t\tborder: none;\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tfont: var(--body-font-four);\r\n\t\tfont-weight: 400;\r\n\t\tcursor: pointer;\r\n\t\tpadding: 4px 8px;\r\n\r\n\t\t&:hover {\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Responsive\r\n@media (max-width: 767px) {\r\n\t.riskAlertCard {\r\n\t\tpadding: 10px 12px;\r\n\r\n\t\t.title {\r\n\t\t\tfont-size: 13px;\r\n\t\t}\r\n\r\n\t\t.message {\r\n\t\t\tfont-size: 13px;\r\n\t\t}\r\n\r\n\t\t.actionButtons {\r\n\t\t\tflex-direction: column;\r\n\r\n\t\t\t.actionBtn {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tjustify-content: center;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// List container\r\n.riskAlertsList {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 12px;\r\n\tlist-style: none;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n}\r\n\r\n// Empty state\r\n.emptyRiskAlerts {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tpadding: 48px 24px;\r\n\ttext-align: center;\r\n\tbackground-color: var(--bg3);\r\n\tborder-radius: var(--border-radius-large);\r\n\r\n\t.emptyIcon {\r\n\t\twidth: 64px;\r\n\t\theight: 64px;\r\n\t\tmargin-bottom: 16px;\r\n\t\topacity: 0.5;\r\n\t}\r\n\r\n\t.emptyTitle {\r\n\t\tfont: var(--body-font-one);\r\n\t\tfont-weight: 600;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tmargin-bottom: 8px;\r\n\t}\r\n\r\n\t.emptyText {\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 400;\r\n\t\tcolor: var(--secondary-Text);\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"riskAlertCard": `riskAlert_riskAlertCard__oxGUO`,
	"unread": `riskAlert_unread__uXcJy`,
	"mainContainer": `riskAlert_mainContainer__sEr3e`,
	"iconContainer": `riskAlert_iconContainer__YJ9dc`,
	"contentContainer": `riskAlert_contentContainer__vxWKh`,
	"headerRow": `riskAlert_headerRow__fdiRF`,
	"titleRow": `riskAlert_titleRow__FE-Pt`,
	"title": `riskAlert_title__-Zjmx`,
	"timeContainer": `riskAlert_timeContainer__BFhjk`,
	"time": `riskAlert_time__4n-CD`,
	"message": `riskAlert_message__JPPoQ`,
	"urgency": `riskAlert_urgency__cLSsv`,
	"clockIcon": `riskAlert_clockIcon__yBdQX`,
	"urgencyText": `riskAlert_urgencyText__C9Meh`,
	"actionsContainer": `riskAlert_actionsContainer__FSPTq`,
	"actionsLabel": `riskAlert_actionsLabel__89G5c`,
	"actionButtons": `riskAlert_actionButtons__9cQan`,
	"actionBtn": `riskAlert_actionBtn__yx7NR`,
	"primary": `riskAlert_primary__GaTww`,
	"secondary": `riskAlert_secondary__G7gFU`,
	"dismissLink": `riskAlert_dismissLink__i7sLX`,
	"riskAlertsList": `riskAlert_riskAlertsList__K8kG6`,
	"emptyRiskAlerts": `riskAlert_emptyRiskAlerts__vDWWM`,
	"emptyIcon": `riskAlert_emptyIcon__hLMB2`,
	"emptyTitle": `riskAlert_emptyTitle__Jl40c`,
	"emptyText": `riskAlert_emptyText__Dwm3d`
};
export default ___CSS_LOADER_EXPORT___;
